var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-container"},[_c('div',{staticClass:"progress2 progress-moved"},[_c('div',{staticClass:"bar",class:{ paused: _vm.pause }})])])}
var staticRenderFns = []

export { render, staticRenderFns }